import React, { useEffect, useState } from 'react';
import { PRODUCT_NAME, PRICE } from '../data/config';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div aria-hidden={!visible} className={['fixed inset-x-0 bottom-0 z-50 border-t border-brass/40 bg-paper px-4 py-3 md:hidden', 'transition-opacity duration-200 ease-out', visible ? 'opacity-100' : 'pointer-events-none opacity-0'].join(' ')} data-id="element-202" data-mp="3pe2aeuggj8yj">
      <div className="flex items-center justify-between gap-3" data-id="element-203" data-mp="3kl95o6kzo0mg">
        <p className="font-mono text-[10px] uppercase leading-[1.4] tracking-label text-ink" data-id="element-204" data-mp="c6h5aamj61tz">
          {PRODUCT_NAME} — {PRICE}
        </p>
        <a href="#pricing" tabIndex={visible ? 0 : -1} className="shrink-0 whitespace-nowrap rounded-sharp bg-brass px-4 py-2.5 font-mono text-[11px] uppercase tracking-label text-ink transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-205" data-mp="gz0fcxm0eeu1">
          Get the system
        </a>
      </div>
    </div>;
}